import { Image as ImageComponent, ImageProps } from '@landler/component-library';

export const Image = ({ className, src, ...delegated }: ImageProps) => {
  return <ImageComponent className={className} src={src} {...delegated} />;
};
